import { Component, OnInit } from '@angular/core';
import { SidebarComponent } from 'libs/shared/src/lib/component/layout/template/sidebar/sidebar.component';

@Component({ standalone: false, selector: 'app-sidebar', templateUrl: './sidebar.component.html' })
export class CustomSidebarComponent extends SidebarComponent implements OnInit {
  constructor() {
    super();
  }
}
